import { useMyWorkspaces } from '../../../app/layout/other-workspaces';
import { errorMessage } from '../../../lib/api';
import { trpc } from '../../../lib/trpc';
import { Section } from '../../../ui/Section';
import { Select } from '../../../ui/Select';
import { toast } from '../../../ui/Toast';

const LAST_USED = 'ostatni';

/**
 * Ustawienia → Profil → „Główny workspace” (DECISIONS 2026-10-08 „Główny workspace”): workspace otwierany po
 * zalogowaniu (`identity.setPrimaryWorkspace`); powiadomienia z innych workspace'ów mają w tytule ich nazwę.
 * Tylko przy kilku workspace'ach. Poczta, integracje i AI zostają per workspace.
 */
export function PrimaryWorkspaceSection() {
  const mine = useMyWorkspaces();
  const utils = trpc.useUtils();
  const save = trpc.identity.setPrimaryWorkspace.useMutation({
    onSuccess: () => utils.identity.listMyWorkspaces.invalidate(),
  });
  const list = mine.data ?? [];
  if (list.length < 2) return null;
  const value = list.find((w) => w.primary)?.id ?? LAST_USED;

  return (
    <Section className="mt-6" title="Główny workspace">
      <p className="text-body-s text-fg-muted">
        Otwiera się po zalogowaniu. Powiadomienia z pozostałych workspace'ów mają w tytule ich nazwę. Poczta, integracje
        i AI działają osobno w każdym workspace'ie.
      </p>
      <Select
        aria-label="Główny workspace"
        className="mt-3 md:max-w-sm"
        value={value}
        disabled={save.isPending}
        options={[
          { value: LAST_USED, label: 'Ostatnio używany' },
          ...list.map((w) => ({ value: w.id, label: w.name })),
        ]}
        onValueChange={(v) =>
          save.mutate(
            { workspaceId: v === LAST_USED ? null : v },
            {
              onSuccess: () => toast.success('Zapisano główny workspace'),
              onError: (err) => toast.error(errorMessage(err)),
            },
          )
        }
      />
    </Section>
  );
}
